import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  FaTicketAlt,
  FaFolderOpen,
  FaCheck,
  FaClock,
} from "react-icons/fa";

// MINI GRAPH COMPONENT
const MiniBars = ({ color }) => {
  const data = [8, 5, 6, 3, 4, 6, 7, 3, 8, 6, 4, 7];

  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: "3px", height: "60px" }}>
      {data.map((val, i) => (
        <div
          key={i}
          style={{
            width: "6px",
            height: `${val * 6}px`,
            background: color,
            borderRadius: "2px",
          }}
        />
      ))}
    </div>
  );
};

const TicketStats = () => {
  const cards = [
    {
      title: "New Tickets",
      count: 120,
      color: "#f97316",
      light: "#fff7ed",
      icon: <FaTicketAlt />,
      border: "#f97316",
    },
    {
      title: "Open Tickets",
      count: 60,
      color: "#a855f7",
      light: "#faf5ff",
      icon: <FaFolderOpen />,
      border: "#a855f7",
    },
    {
      title: "Solved Tickets",
      count: 50,
      color: "#22c55e",
      light: "#f0fdf4",
      icon: <FaCheck />,
      border: "#22c55e",
    },
    {
      title: "Pending Tickets",
      count: 10,
      color: "#06b6d4",
      light: "#ecfeff",
      icon: <FaClock />,
      border: "#06b6d4",
    },
  ];

  return (
    <Row>
      {cards.map((item, index) => (
        <Col xl={3} md={6} sm={12} key={index} className="mb-3">
          <Card
            style={{
              borderRadius: "5px",
              border: "1px solid #e5e7eb",
            }}
          >
            <Card.Body>
              <div className="d-flex justify-content-between">

                {/* LEFT */}
                <div>
                  <div
                    style={{
                      border: `1px dashed ${item.border}`,
                      borderRadius: "50%",
                      padding: "6px",
                      display: "inline-flex",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "45px",
                        height: "45px",
                        borderRadius: "50%",
                        background: item.light,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: item.color,
                        fontSize: "18px",
                      }}
                    >
                      {item.icon}
                    </div>
                  </div>

                  <p
                    style={{
                      fontSize: "13px",
                      color: "#6b7280",
                      marginBottom: "5px",
                    }}
                  >
                    {item.title}
                  </p>

                  <h4 style={{ fontWeight: "600" }}>{item.count}</h4>
                </div>

                {/* RIGHT */}
                <div style={{ textAlign: "right" }}>
                  <span
                    style={{
                      fontSize: "12px",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      background: item.light,
                      color: item.color,
                      display: "inline-block",
                      marginBottom: "10px",
                    }}
                  >
                    ↗ +19.01%
                  </span>

                  <MiniBars color={item.color} />
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default TicketStats;